/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Forms = {
    type: 'array',
    contains: {
        type: 'ResponseForm',
    },
};